import { types, flow, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { makeRequest, errorResponse } from 'js/services/Network';

export const transactionDescriptionTranslation = {
  'admin-void': 'Void transaction',
  'user-payout': 'Seller payout',
  'ach-verification-credit': 'Verification credit',
  'ach-verification-debit': 'Verification debit',
  'buyer-purchase': 'Buyer purchase',
  'buyer-auth': 'Buyer purchase auth',
  'seller-sale': 'Seller sale credit',
  'seller-auth': 'Seller sale verification auth',
  'buyer-auth-completion': 'Buyer purchase auth completion',
  'buyer-return-shipping': 'Buyer return penalty',
  'buyer-return-completion': 'Buyer return penalty charge',
  'buyer-return-shipping-remaining-charge': 'Buyer return penalty charge (remaining)',
  'buyer-return-completion-credit': 'Buyer return penalty remainder refund',
  'seller-not-shipped-penalty': 'Seller item not shipped penalty',
  'seller-not-shipped-charge': 'Seller item not shipped charge',
};

export default types
  .model('Transaction', {
    isLoading: false,
    error: types.maybeNull(types.string),
    isVoiding: false,
    showVoidPrompt: false,
    wasVoid: false,

    id: types.maybe(types.number),
    parent_id: types.maybeNull(types.number),
    void_id: types.maybeNull(types.number),
    creator_name: types.maybeNull(types.string),
    creator_email: types.maybeNull(types.string),
    human_label: types.maybeNull(types.string),
    result_label: types.maybeNull(types.string),
    result: types.maybeNull(types.string),
    can_void: types.maybeNull(types.boolean),
    user_name: types.maybe(types.string),
    user_email: types.maybe(types.string),
    bank_account: types.maybeNull(types.string),
    bank_account_id: types.maybeNull(types.number),
    credit_card: types.maybeNull(types.string),
    credit_card_id: types.maybeNull(types.number),
    order_item: types.maybeNull(types.string),
    order_uid: types.maybeNull(types.string),
    description: types.maybe(types.string),
    is_successful: types.maybe(types.boolean),
    is_void: types.maybe(types.boolean),
    item_price: types.maybe(types.number),
    amount: types.maybe(types.number),
    shipping: types.maybe(types.number),
    pod_revenue: types.maybe(types.number),
    settlement_fee: types.maybe(types.number),
    interchange_fee: types.maybe(types.number),
    credit_applied: types.maybe(types.number),
    pod_margin: types.maybe(types.number),
    buyer_payed: types.maybe(types.number),
    seller_settlement: types.maybe(types.number),
    fee: types.maybe(types.number),
    created_at: types.maybe(types.string),
    logo_type: types.maybe(types.string),
    logo: types.maybeNull(types.string),
  })
  .views(self => ({
    get human_description() {
      return transactionDescriptionTranslation[self.description] || '';
    },
    get logo_src() {
      return self.logo_type === 'bank_institution' ? `data:image/jpeg;base64,${self.logo}` : self.logo;
    },
    get status() {
      if (self.is_successful) {
        return self.is_void ? 'void' : 'successful';
      }
      return 'failed';
    },
  }))
  .actions(self => ({
    setId(id) {
      self.id = id;
      return self;
    },

    load: flow(function* load() {
      let response;

      if (!self.isLoading) {
        self.isLoading = true;
        self.error = null;

        try {
          response = yield makeRequest('admin-transaction-data', self);
          applySnapshot(self, { ...getSnapshot(self), ...response.data });
        } catch (error) {
          self.error = errorResponse(error);
        }

        self.isLoading = false;
      }

      return response;
    }),

    promptVoid: flow(function* promptVoid() {
      self.isVoiding = false;
      self.showVoidPrompt = true;
    }),

    closeVoidPrompt() {
      self.showVoidPrompt = false;
    },

    voidTransaction: flow(function* voidTransaction() {
      let response;

      if (!self.isVoiding) {
        self.isVoiding = true;

        try {
          response = yield makeRequest('admin-void-transaction', self);
          applySnapshot(self, { ...getSnapshot(self), ...response.data });
        } catch (error) {
          PubSub.publish('popup-text', { type: 'error', message: errorResponse(error) });
        }

        self.showVoidPrompt = false;
      }

      return response;
    }),
  }));
